export default __webpack_public_path__ + "static/forgetpassword-2c97fed5d3ba94906babb11a0798bfeb.png";